import { MutableRefObject, useEffect, useRef } from 'react';

/** It is used when we need to remember previous value of a variable...we store previous value in ref */
export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T | undefined>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
